/**
 * Single source of truth for "take me to the booking action".
 *
 * Every CTA on the landing must land the visitor on the qualification wizard
 * (the actual thing we want them to do), NOT at the top of the contact
 * section where they would first meet a wall of persuasion copy they already
 * read on the way down.
 *
 * Falls back to the contact section if the wizard is not mounted.
 */
export function scrollToBooking() {
  const target =
    document.getElementById('calificar') || document.getElementById('contacto')
  target?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  })
}
